import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'ngx-provider-renderer',
  templateUrl: './provider-renderer.component.html',
  styleUrls: ['./provider-renderer.component.scss']
})
export class ProviderRendererComponent implements ICellRendererAngularComp {

  providerIds = [];
  idSources = {8: 'netflix.png', 10: 'amazonPrime.png', 337: 'disneyPlus.png'};

  constructor() { }

  agInit(params: any): void {
    this.providerIds = params.data.providers;
  }

  refresh(): boolean {
    return false;
  }

}
